module.exports = __webpack_public_path__ + "static/media/ahkviwer.1fd484c3.png";